import React, { useState, useEffect } from 'react';
import {
	HStack,
	Box,
	Image,
	Text,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Icon,
} from '@chakra-ui/react';

import { LuChevronDown } from 'react-icons/lu'


import Headerlogo from '../images/Logo.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../index.css";
import { fetchWrapper } from '../helpers';
import { toast } from 'react-toastify';

function Header() {

	const [email, setEmail] = useState('');

	const location = useLocation();
	const navigate = useNavigate()


	useEffect(() => {
		const token = localStorage.getItem('user');

		if (token) {
			const decodedToken = decodeToken(token);
			const Userdata = decodedToken.userdata;
			setEmail(Userdata.username);
		}
	}, []);

	const decodeToken = (token) => {
		const decodedString = atob(token.split('.')[1]);
		const decodedObject = JSON.parse(decodedString);
		return decodedObject;
	};

	const Logout = async () => {
		const url = `${process.env.REACT_APP_API_URL}/user/logout`;
		const res = await fetchWrapper.post(url, {})
		if (res.success) {
			localStorage.removeItem('user')
			navigate("/")
		} else {
			toast.error("Logout failed")
		}
	}


	return (
		<div style={{ position: "sticky", top: "0", zIndex: "999", background: "white", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)", borderBottom: "1px solid #0000001a" }}>

			{/* Top bar: logo + user account */}
			<HStack px="20px" py="0px" h="54px" justifyContent="space-between" bg="white" className="header_section" borderBottom="1px solid" borderColor="#0000001a">
				<Box display="flex" alignItems="center">
					<Link to="/dashboard">
						<Image src={Headerlogo} alt='XNotify' w="auto" h="34px" />
					</Link>
				</Box>
				<Box>
					<Menu>
						<MenuButton className="header-user-button">
							<HStack spacing="6px">
								<Box>
									<Text mb="0" fontSize="11px" fontWeight="400" color="#9ca3af" lineHeight="1.2" textAlign="left">Signed in as</Text>
									<HStack spacing="3px">
										<Text mb="0" fontSize="13px" fontWeight="500" color="#111827">{email}</Text>
										<Icon as={LuChevronDown} boxSize={3.5} color="#6b7280" />
									</HStack>
								</Box>
							</HStack>
						</MenuButton>
						<MenuList>
							<MenuItem onClick={() => Logout()}>Logout</MenuItem>
						</MenuList>
					</Menu>
				</Box>
			</HStack>

			{/* Navigation bar */}
			<HStack h="44px" bg="white" py="0px" px="70px" justifyContent="center" className="header_section">
				<HStack spacing="0px" h="100%">

					<Box className="nav-item">
						<Link to="/dashboard" className={location.pathname === "/dashboard" ? "active" : ""}>Dashboard</Link>
					</Box>

					<Box className="nav-item">
						<Link to="/customer" className={location.pathname === "/customer" ? "active" : ""}>Customers</Link>
					</Box>

					<Box className="nav-item">
						<Link to="/cron-manager" className={location.pathname === "/cron-manager" ? "active" : ""}>Cron Manager</Link>
					</Box>

					<Box className="nav-item">
						<Menu>
							<MenuButton className={`nav-dropdown-trigger ${location.pathname === "/demo-request" || location.pathname === "/voucher-codes" || location.pathname === "/estimates" ? "active" : ""}`}>
								<HStack spacing="3px">
									<span>Website</span>
									<Icon as={LuChevronDown} boxSize={3} />
								</HStack>
							</MenuButton>
							<MenuList>
								<MenuItem>
									<Link to="/demo-request">Demo Request</Link>
								</MenuItem>
								<MenuItem>
									<Link to="/voucher-codes">Voucher Codes</Link>
								</MenuItem>
								<MenuItem>
									<Link to="/estimates">Estimates</Link>
								</MenuItem>
							</MenuList>
						</Menu>
					</Box>

					<Box className="nav-item">
						<Menu>
							<MenuButton className={`nav-dropdown-trigger ${location.pathname === "/price" || location.pathname === "/sale-channel" || location.pathname === "/billings" ? "active" : ""}`}>
								<HStack spacing="3px">
									<span>Pricing</span>
									<Icon as={LuChevronDown} boxSize={3} />
								</HStack>
							</MenuButton>
							<MenuList>
								<MenuItem>
									<Link to="/price">Price List</Link>
								</MenuItem>
								<MenuItem>
									<Link to="/sale-channel">Sales Contracts</Link>
								</MenuItem>
								<MenuItem>
									<Link to="/billings">Billings</Link>
								</MenuItem>
							</MenuList>
						</Menu>
					</Box>

					<Box className="nav-item">
						<Menu>
							<MenuButton className={`nav-dropdown-trigger ${location.pathname === "/message" || location.pathname.startsWith("/web-hook") ? "active" : ""}`}>
								<HStack spacing="3px">
									<span>Logs</span>
									<Icon as={LuChevronDown} boxSize={3} />
								</HStack>
							</MenuButton>
							<MenuList>
								<MenuItem>
									<Link to="/message">Message Log</Link>
								</MenuItem>
								<MenuItem>
									<Link to="/web-hook">Webhook Logs</Link>
								</MenuItem>
							</MenuList>
						</Menu>
					</Box>

					{/* <Box className="nav-item">
						<Link to="/message-builder" className={location.pathname.startsWith("/message-builder") ? "active" : ""}>Message Builder</Link>
					</Box> */}

					<Box className="nav-item">
						<Link to="/send-message" className={location.pathname.startsWith("/send-message") ? "active" : ""}>Send Message</Link>
					</Box>

					<Box className="nav-item">
						<Link to="/template-manager" className={location.pathname === "/template-manager" ? "active" : ""}>Template Manager</Link>
					</Box>
					<Box className="nav-item">
						<Link to="/sdk-config" className={location.pathname === "/sdk-config" ? "active" : ""}>SDK Documentation</Link>
					</Box>

					<Box className="nav-item">
						<Link to="/settings" className={location.pathname.startsWith("/settings") ? "active" : ""}>Settings</Link>
					</Box>

				</HStack>
			</HStack>

		</div>
	);
}

export default Header;
